import React from "react";
import { inject, observer } from "mobx-react";
import { withStyles, IconButton } from "@material-ui/core";
import { compose } from "recompose";
import clsx from "clsx";
import Tooltip from "../../../common/StyledToolTip";
import { SavePreferences } from "../../../../utilities/appHelper";
import { withUserProfile } from "../../../../userProfile/userProfileContext";
import ExpandMoreIcon from "@material-ui/icons/ExpandMore";
import KPIRow from "./components/KPIRow";
import appConstants from "../../../../appConstants";
import styles from "./styles";
import { AppLoading } from "../../../../loaders/loaders";
import Events from "../../../../utilities/EventEmitter";
import Retry from "./components/Retry";
import { loadDispatchKPIData } from "./utils";
import ReturnShipments from "./ReturnShipments";

@inject("DispatchStore")
@observer
class KPIPanel extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      expand: false,
      isDataLoaded: this.props.DispatchStore.kpiData.length > 0,
    };
    this.expandHeight = 128;
    this.initialHeight = this.props.glContainer.height + 10;
  }

  componentDidMount() {
    Events.on("DispatchKPI", this.handleDataLoadStatus);
    this.setSavedExpandPreferences();
  }

  componentWillUnmount() {
    Events.removeListener("DispatchKPI", this.handleDataLoadStatus);
  }

  handleDataLoadStatus = (isDataLoaded) => {
    this.setState({ isDataLoaded });
  };

  setSavedExpandPreferences = () => {
    if (
      !this.state.isDataLoaded ||
      this.props.DispatchStore.kpiData.length === 0
    ) {
      return;
    }
    this.setState(
      {
        expand: this.getSavedExpandPreferences(),
      },
      this.setContainerHeight
    );
  };

  handleKPIRetry = () => {
    this.setState({
      isDataLoaded: false,
    });
    const kpiDataPromise = loadDispatchKPIData(
      this.props.userData.userProfile.terminal.code
    );
    kpiDataPromise.then((response) => {
      this.setState({
        isDataLoaded: true,
      });
      if (response && response.status === 200) {
        this.props.DispatchStore.updateKPIData(response.data);
        this.setSavedExpandPreferences();
      } else {
        this.props.DispatchStore.updateKPIData([]);
      }
    });
  };

  getSavedExpandPreferences = () => {
    const isKPIExpanded =
      this.props.userData.userProfile?.columnPref?.[
        `${appConstants.KPI_NAME.DispatchKPI}_Config`
      ]?.isKPIExpanded ?? false;
    return isKPIExpanded;
  };

  setContainerHeight = () => {
    const newHeight =
      this.state.isDataLoaded && this.state.expand
        ? this.expandHeight
        : this.initialHeight;
    this.props.glContainer.parent.container.setSize(false, newHeight);
  };

  handleExpandClick = () => {
    this.setState(
      (prevState) => ({
        expand: !prevState.expand,
      }),
      () => {
        this.saveKPIExpandPreference();
        this.setContainerHeight();
      }
    );
  };

  saveKPIExpandPreference = () => {
    const { expand } = this.state;
    let { columnPref, userId } = this.props.userData.userProfile;
    if (!columnPref) {
      columnPref = {};
    }
    const storedConfig =
      columnPref[`${appConstants.KPI_NAME.DispatchKPI}_Config`] ?? {};
    SavePreferences({
      name: `${appConstants.KPI_NAME.DispatchKPI}_Config`,
      config: { ...storedConfig, isKPIExpanded: expand },
      userColumnPref: columnPref,
      userId,
    });
  };

  render() {
    const kpiData = this.props.DispatchStore.kpiData;
    const pivotPoint = 3;
    const firstRowKPIData = kpiData.slice(0, pivotPoint);
    const secondRowKPIData = kpiData.slice(pivotPoint);
    const { classes } = this.props;
    const { expand, isDataLoaded } = this.state;
    if (!isDataLoaded) {
      return (
        <div id="appContainer" className={classes.layout}>
          <AppLoading />
        </div>
      );
    } else if (kpiData.length === 0) {
      return <Retry onClick={this.handleKPIRetry} />;
    }
    return (
      <div className={`${classes.kpiContainer} customScroll`}>
        <div className={classes.rowContainer}>
          <Tooltip
            title={expand ? "Expand less" : "Expand more"}
            disableFocusListener
          >
            <IconButton
              className={clsx(classes.expand, {
                [classes.expandOpen]: expand,
              })}
              onClick={this.handleExpandClick}
              aria-expanded={expand}
            >
              <ExpandMoreIcon className={classes.expandIcon} />
            </IconButton>
          </Tooltip>
          <KPIRow rowData={firstRowKPIData} />
        </div>
        {expand && (
          <div className={classes.lastRowContainer}>
            <KPIRow rowData={secondRowKPIData} />
          </div>
        )}
        <ReturnShipments userProfile={this.props.userData.userProfile} />
      </div>
    );
  }
}

export default compose(withStyles(styles), withUserProfile)(KPIPanel);
